module.exports = __webpack_public_path__ + "03_glasses_black.c4a915cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer4/03_glasses_black.png
// module id = o7e0
// module chunks = 0